
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import TractorUnitList from './List';
import TractorUnitAdd from './Add';
import TractorUnitDetail from './Detail';


export default class TractorUnitRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/tractor_unit" exact component={TractorUnitList} />
        <Route path="/tractor_unit/add" exact component={TractorUnitAdd} />
        <Route path="/tractor_unit/:id" component={TractorUnitDetail} />
      </Switch>
    );
  }
}
